import { Component, OnInit } from '@angular/core';

import { AuthService } from './../../../services/auth.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  userData: any;
  loader = true;
  constructor(
    private authService: AuthService,
  ) {
  }

  ngOnInit() {
    this.authService.membersDataSubscription.subscribe(response => {
      if (response) {
        this.userData = response;
        setTimeout(() => {
          this.loader = false;
        }, 500);
      }
    });
  }

}
